import { BookingResponse } from '@/api/data-contracts';
import { supportNames } from '@/shared/constants';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** A booking's live decorations come in sequence: the first is its initial decoration, the rest redecorations. */
export const decorationTitle = (t: Translate, index: number): string =>
  index === 0
    ? t('artwork_drive.initial_decoration')
    : t('artwork_drive.redecoration', { number: index });

/** A booking as people tell it apart in Drive: its support and the space's support id. */
export const supportDriveLabel = (
  support: string | undefined,
  supportId: string | undefined,
): string =>
  [supportNames.find((name) => name.value === support)?.label, supportId].filter(Boolean).join(' ');

export const bookingDriveLabel = (booking: BookingResponse): string => {
  const space = booking.space?.spaceResponse;

  return supportDriveLabel(space?.support, space?.supportId) || booking.id;
};
